import {
    Configuration,
    FetchAPI,
    HTTPHeaders,
    StripeControllerApi,
    WidgetControllerApi
} from "./generated";

export enum RequestStatus {
    NONE,
    PENDING,
    RESOLVED,
    REJECTED
}

export const globalFetchConfig: FetchAPI = async (originalReqUrl: Request | string,
                                                  originalReqParams: RequestInit | undefined) => {
    const headers = new Headers(originalReqParams?.headers || {});
    headers.set("Content-Type", "application/json");

    return fetch(originalReqUrl, {
        ...originalReqParams,
        headers,
    });
}

export const createDefaultHeaders = (): HTTPHeaders => {
    const headers: HTTPHeaders = {};
    headers['Content-Type'] = 'application/json';
    return headers;
}

const ApiClientConfig = (basePath: string) => new Configuration(
    {
        basePath,
        fetchApi: globalFetchConfig,
        headers: createDefaultHeaders()
    }
)

export const widgetApi = (basePath: string) => {
    return new WidgetControllerApi(ApiClientConfig(basePath));
}

export const stripeApi = (basePath: string) => {
    return new StripeControllerApi(ApiClientConfig(basePath));
}
